




















import PointOfServiceForm from '@/components/pointofservice/PointOfServiceForm.vue';
import PointOfServiceUtils, {
  PointOfService,
} from '@/utils/PointOfServiceUtils';
import Vue from 'vue';

export default Vue.extend({
  components: { PointOfServiceForm },

  data(): {
    state: {
      valid: boolean;
      submit: boolean;
      errors?: any[];
    };
    item?: Partial<PointOfService>;
  } {
    return {
      state: {
        valid: false,
        submit: false,
        errors: undefined,
      },
      item: undefined,
    };
  },

  async mounted() {
    this.item = PointOfServiceUtils.pointOfService.generateDefault();
  },

  methods: {
    async handleSubmit() {
      if (this.item) {
        try {
          this.state.errors = undefined;
          this.state.submit = true;
          (this.$refs.form as any).validate();
          this.item = await PointOfServiceUtils.api.create(this.item);
          await PointOfServiceUtils.api.generateSearchDataset(this.item?.id);
          (this.$refs.form as any).resetValidation();
          this.$toast.push({
            text: this.$t('success.create', [this.$tc('pointofservice.label')]),
            type: 'success',
          });
          this.$router.replace({ name: 'pointofservice-list' });
        } catch (error: any) {
          this.$toast.push({
            text: this.$t('error.create', [this.$tc('pointofservice.label')]),
            type: 'error',
          });
          this.state.errors = error; // TODO: handle errors
        } finally {
          this.state.submit = false;
        }
      }
    },
  },
});
